import _taggedTemplateLiteral from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf2 from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _decorate from "@babel/runtime/helpers/esm/decorate";
import _get from "@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

var _ = function _(t) {
  return t;
},
    _t;
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


import { html, customElement, LitElement } from 'lit-element';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import settings from 'carbon-components/es/globals/js/settings';
import styles from "./tag-group.css.js";
var ddsPrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * Tag Group
 *
 * @element dds-tag-group
 */

var DDSTagGroup = _decorate([customElement("".concat(ddsPrefix, "-tag-group"))], function (_initialize, _LitElement) {
  var DDSTagGroup = /*#__PURE__*/function (_LitElement2) {
    _inherits(DDSTagGroup, _LitElement2);

    var _super = _createSuper(DDSTagGroup);

    function DDSTagGroup() {
      var _this;

      _classCallCheck(this, DDSTagGroup);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _initialize(_assertThisInitialized(_this));

      return _this;
    }

    return DDSTagGroup;
  }(_LitElement);

  return {
    F: DDSTagGroup,
    d: [{
      kind: "method",
      key: "_handleSlotChange",
      value:
      /**
       * Handler for @slotchange, ensure that the only elements being rendered are BXTag and DDSTagLink
       *
       * @private
       */
      function _handleSlotChange(event) {
        var _this2 = this;

        var childItems = event.target.assignedNodes();
        var carbonTags = childItems.filter(function (elem) {
          return elem.matches !== undefined ? elem.matches(_this2.constructor.selectorTag) : false;
        });
        var carbonReactTags = childItems.filter(function (elem) {
          return elem.matches !== undefined ? elem.classList.contains(_this2.constructor.selectorReactTag) : false;
        }); // Handle color setting differently depending on Carbon WC or Carbon React

        carbonTags.forEach(function (elem) {
          if (!elem.hasAttribute('type') || elem.getAttribute('type') === 'gray') {
            elem.setAttribute('type', 'green');
          }
        });
        carbonReactTags.forEach(function (elem) {
          if (!elem.className.split(' ').some(function (c) {
            return /^bx--tag--/.test(c);
          })) {
            elem.classList.add("".concat(prefix, "--tag--green"));
          }
        });
      }
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        return html(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <slot @slotchange=\"", "\"></slot>\n    "])), 0)), this._handleSlotChange);
      }
    }, {
      kind: "method",
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(DDSTagGroup.prototype), "connectedCallback", this).call(this);

        this.setAttribute('role', 'list');
      }
      /**
       * A selector that will return the DDSTagLink child items.
       */

    }, {
      kind: "get",
      static: true,
      key: "selectorTagLink",
      value: function selectorTagLink() {
        return "".concat(ddsPrefix, "-tag-link");
      }
      /**
       * A selector that will return the BXTag child items.
       */

    }, {
      kind: "get",
      static: true,
      key: "selectorTag",
      value: function selectorTag() {
        return "".concat(prefix, "-tag");
      }
      /**
       * A selector that will return the BXTag child items.
       */

    }, {
      kind: "get",
      static: true,
      key: "selectorReactTag",
      value: function selectorReactTag() {
        return "".concat(prefix, "--tag");
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function stableSelector() {
        return "".concat(ddsPrefix, "--tag-group");
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value: function value() {
        return styles;
      }
    }]
  };
}, LitElement);
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */


export default DDSTagGroup;